module.exports = __webpack_public_path__ + "static/woody_consult_preview-ec29e2fbacdb6ec225cf8ae3d3185ffa.jpg";